import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSuccess = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		x: 6,
		y: 6,
		width: 20,
		height: 20,
		rx: 10,
		fill: "white"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M12 17.1888L14.7179 20.1538L20.8333 12",
		stroke: "#7CDEAF",
		strokeWidth: 1.5,
		strokeLinecap: "round"
	})]
});
export default SvgSuccess;
